import script from "./ReloadNotification.vue?vue&type=script&setup=true&lang=js"
export * from "./ReloadNotification.vue?vue&type=script&setup=true&lang=js"

import "./ReloadNotification.vue?vue&type=style&index=0&id=298ce8e8&lang=css"

const __exports__ = script;

export default __exports__